import { render } from "./webinar-details.vue?vue&type=template&id=3b070f7d"
import script from "./webinar-details.vue?vue&type=script&lang=js"
export * from "./webinar-details.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__